// Module
var code = "<div class=\"alertBox alertBox--energized mapOfflineBackground\">\n    <p class=\"mapOfflineBackgroundText\">{[L('CustomerView.NoMapsService', 'Sorry, no service available')]}</p>\n    <div class=\"mapOfflinePointer\"></div>\n</div>\n";
// Exports
module.exports = code;